import {combineReducers} from 'redux'
import emails from './emails'
import messages from './messages'
import language from './language'
import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
	emails,
	messages,
	language,
	form: formReducer
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/redux/reducers/rootReducer.js